import { Button, Card } from "react-bootstrap";
import { PranchetasMP } from "../../../Icons";
import './style.css'
import { useNavigate } from "react-router-dom";

const AsoContinuar = () => {
    const navigate = useNavigate();

    return(
        <>
            <Card className="aso-card">
                <Card.Body className='aso-card-body'>
                    <div className="icon-text-container d-flex flex-column align-items-center padding">
                        <PranchetasMP/>
                        <Card.Title className='cardTitle text-center'>Para criar uma conta empresa, precisamos que você tenha autorização legal</Card.Title>
                        <Card.Text className='cardSubTitle text-center'>Certifique-se de ter a documentação que comprove que você é algum desses tipos de representante:</Card.Text>
                        <ul className="ul">
                            <li>Administrador(a)</li>
                            <li>Acionista</li>
                            <li>Mandatário(a)</li>
                            <li>Representante Legal</li>
                            <li>Procurador(a)</li>
                        </ul>
                        <Button variant="primary" className="btn-aso mb-2 mt-2 w-50" 
                        onClick={() => navigate(`/aso/registro/validar-info-empresa`)}>Continuar</Button>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
}

export default AsoContinuar;